import payloadApi from '../api/payloadApi';
import secondaryPayloadApi from '../api/secondaryPayloadApi';
import { loadBrandsSuccess, brandPrepopulated } from './brandActions';
import { loadAdSuccess } from './adActions';
import { loadDevicesSuccess, devicePrepopulated } from './deviceActions';
import { loadModelsSuccess } from './modelActions';
import { setFinderTypeId } from './finderTypeIdActions';
import { loadConfigPropsSuccess } from './configPropActions';

export function loadPayload(brandId, deviceId, finderTypeId) {
    return function (dispatch) {
        return payloadApi.getPayload(brandId, deviceId, finderTypeId).then(payload => {
            dispatch(loadBrandsSuccess(payload.brands));
            dispatch(loadConfigPropsSuccess(payload.configPropValues));

            if (payload.devices) {
                dispatch(loadDevicesSuccess(payload.devices));
                if (payload.devices.length > 0) {
                    dispatch(brandPrepopulated(brandId));
                }
            }
            if (payload.models) {
                dispatch(loadModelsSuccess(payload.models));
                if (payload.models.length > 0) {
                    dispatch(devicePrepopulated(brandId, deviceId));
                }
            }

            if (finderTypeId) {
                dispatch(setFinderTypeId(finderTypeId));
            }
            else {
                dispatch(setFinderTypeId(payload.configPropValues["Ink and Toner Finder Type"] ? payload.configPropValues["Ink and Toner Finder Type"] : "InkAndTonerMatch"));
            }

        }).catch(error => {
            throw (error);
        });
    };
}

export function loadSecondaryPayload() {
    return function (dispatch) {
        return secondaryPayloadApi.getSecondaryPayload().then(payload => {
            dispatch(loadAdSuccess(payload.customPageHTML));
        }).catch(error => {
            throw (error);
        });
    };
}